/**
 * Created by neo on 14.11.2023
 */
import { makeAutoObservable } from 'mobx';
import { RouteLocationPositionType } from './RouteLocationPositionType';

export type RouteChallengeLocationPosition = {
  type: RouteLocationPositionType;
  xorLat: number;
  yorLng: number;
  toJS(): RouteChallengeLocationPosition;
};

export function createRouteChallengeLocationPosition(json?: Partial<RouteChallengeLocationPosition>): RouteChallengeLocationPosition {
  return makeAutoObservable({
    type: json?.type ?? 'coordinates',
    xorLat: json?.xorLat ?? 0,
    yorLng: json?.yorLng ?? 0,

    toJS(): RouteChallengeLocationPosition {
      return {
        type: this.type,
        xorLat: this.xorLat,
        yorLng: this.yorLng,
        toJS: this.toJS,
      };
    },
  });
}
